<template>
<m-pageframe
    title="{organization-label}: Edit Media Assets"
>
<v-container
    style="padding-left: 15px; padding-right: 15px"
    fluid
>

    <m-media-asset-search
        :organization_id="$route.params.organization_id"
        :content_type="$route.params.content_type"
    />

  

</v-container>
</m-pageframe>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
</style>